export enum AlertMutationTypes {
  SET_ALERTCONDITION_CATS = "SET_ALERTCONDITION_CATS",
}